import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";

import knowledgebaseAgentService from "../../services/knowledgebase-agent.service";

// Multi-step form
import MultiStepForm from "../../pages/agent/MultiStepForm";

const AgentEditNew = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadKB = async () => {
      try {
        if (!id) {
          if (isMounted) setError("Invalid Knowledge Base ID");
          return;
        }

        setLoading(true);

        const kb = await knowledgebaseAgentService.getKnowledgeBaseById(id);

        if (!kb) {
          if (isMounted) setError("Knowledge Base not found");
          return;
        }

        if (isMounted) {
          setInitialData(kb);
        }
      } catch (err) {
        console.error("Failed to load KB:", err);
        if (isMounted) {
          setError(err?.message || "Failed to load knowledge base");
        }
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    loadKB();

    return () => {
      isMounted = false;
    };
  }, [id]);

  /* ------------------ UI STATES ------------------ */

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
        <Typography mt={2}>Loading Knowledge Base...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ maxWidth: 800, mx: "auto", mt: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!initialData) return null;

  return <MultiStepForm mode="edit" agentId={id} initialData={initialData} />;
};

export default AgentEditNew;
